// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fade-enter-active[data-v-49697194], .fade-leave-active[data-v-49697194] {\n  transition: all 0.3s ease;\n}\n.fade-enter-from[data-v-49697194], .fade-leave-to[data-v-49697194] {\n  transform: translateY(-20%);\n  opacity: 0;\n}", ""]);
// Exports
module.exports = exports;
